import { render, staticRenderFns } from "./projectStaffModal.vue?vue&type=template&id=6cb38b70&"
import script from "./projectStaffModal.vue?vue&type=script&lang=js&"
export * from "./projectStaffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports